import React, { useMemo } from 'react';
import { useTasks } from '../../../../../../data/hooks/schedule/useTasks';
import GroupedProgramItems from '../../../common/GroupedProgramItems';
import { mergeProgramAndSchedule } from '../../../mergeProgramAndSchedule';
import useScheduleMeetings from '../../../useScheduleMeetings/useScheduleMeetings';

function ScheduleTasks(props) {
    const { event, date, dateFilter, focusedRoundId } = props,
        sessions = useTasks(event.id, {
            filter: dateFilter,
        }),
        meetings = useScheduleMeetings(event.id, { filter: dateFilter }),
        mergedItems = useMemo(() => mergeProgramAndSchedule(sessions, meetings), [sessions, meetings]);

    return <GroupedProgramItems event={event} items={mergedItems} focusedRoundId={focusedRoundId} />;
}

export default ScheduleTasks;
